import { HTMLAttributes, useRef } from 'react';

import Link from 'next/link';
import { useInViewport } from 'react-in-viewport';

import { setCursor } from '@/utils/Cursor/Cursor';

interface HiddenAnchorProps extends HTMLAttributes<HTMLAnchorElement> {
	/**
	 * THe link when the link is clicked.
	 */
	href: string;
}

const HiddenAnchor = ({ id, href, className, ...props }: HiddenAnchorProps) => {
	const anchorRef = useRef<HTMLAnchorElement>(null);

	useInViewport(
		anchorRef,
		{ threshold: 0.1 },
		{ disconnectOnLeave: false },
		{
			onEnterViewport: () => {
				if (!window) return;

				const anchor = anchorRef.current;

				if (anchor?.id !== '') {
					setCursor(anchor?.id as string);
				}

				if (!anchor) return;
			},
		}
	);

	return (
		<Link ref={anchorRef} id={id} href={href}>
			<a {...props} className="w-full h-3" />
		</Link>
	);
};

export default HiddenAnchor;
